// hooks/useFavorites.jsx



import { useState, useEffect } from "react";
import {
  getFirestore,
  doc,
  updateDoc,
  arrayUnion,
  arrayRemove,
  getDoc,
} from "firebase/firestore";
import { useAuth } from "./useAuth";

const firestore = getFirestore();

const useFavorites = () => {
  const { currentUser } = useAuth();
  const [favorites, setFavorites] = useState([]);

  useEffect(() => {
    if (!currentUser) {
      setFavorites([]);
      return;
    }

    const fetchFavorites = async () => {
      const userDoc = await getDoc(doc(firestore, "users", currentUser.uid));
      if (userDoc.exists()) {
        setFavorites(userDoc.data().favorites || []);
      }
    };

    fetchFavorites();
  }, [currentUser]);

  // ✅ Now saves image URL along with title and id
  const addFavorite = async (listingId, listingTitle, imageUrl) => {
    if (!currentUser) return;
    try {
      const userDocRef = doc(firestore, "users", currentUser.uid);
      const favoriteItem = {
        id: listingId,
        title: listingTitle,
        imageUrl: imageUrl || "placeholder.jpg", // Use default if image missing
      };
      await updateDoc(userDocRef, {
        favorites: arrayUnion(favoriteItem),
      });
      setFavorites((prevFavorites) => [...prevFavorites, favoriteItem]);
    } catch (error) {
      console.error("Error adding favorite:", error);
    }
  };

  const removeFavorite = async (listingId) => {
    if (!currentUser) return;
    try {
      const userDocRef = doc(firestore, "users", currentUser.uid);
      const favoriteToRemove = favorites.find((fav) => fav.id === listingId);
      await updateDoc(userDocRef, {
        favorites: arrayRemove(favoriteToRemove),
      });
      setFavorites((prevFavorites) =>
        prevFavorites.filter((fav) => fav.id !== listingId)
      );
    } catch (error) {
      console.error("Error removing favorite:", error);
    }
  };

  const isFavorite = (listingId) =>
    favorites.some((fav) => fav.id === listingId);

  return { favorites, addFavorite, removeFavorite, isFavorite };
};

export default useFavorites;
